import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'notDefinedWhenNull'})
export class NotDefinedWhenNullPipe implements PipeTransform {
  transform(value: string): string {
    return  value ? value : 'N/D';
  }
}
